<script>
import { ref, reactive, computed, toRefs } from 'vue'
import { useStore } from 'vuex'
import { routeTo } from '@/utils'
import CertTypeSelect from './components/cert-type-select'
import {
  getCompShareholderInfo,
  addCompanyShareholderInfo,
  getCompanyInfo,
  updateCompShareholderInfo
} from "@/api/modules/auth"
import { vab } from "@libs/utils"
import { useI18n } from "@/plugins/i18n"

export default {
  name: 'AuthShareholder',
  components: { CertTypeSelect },
  setup() {
    const store = useStore()
    const nextOrUpdate = computed(() => +store.state.auth.step !== 4 ? 'next' : 'update')
    const areaCountryList = store.state.base.dict.country.countryCodeList
    const { formReq, loadingScope, certs, handleAddDirector, handleDelDirector } = initForm()
    const { t } = useI18n()
     // refs
    const refs = reactive({
      formRef: null
    })

    const scopedMethods = {
      // 上一步
      handlePrev: () => {
        routeTo('/auth/company/info')
      },

      checkCert: async (arr, index, res) => {

        if (arr.length != index) {
          let itemVal = await arr[index].validateForm();
          if (itemVal) {
            return scopedMethods.checkCert(arr, index + 1, true);
          } else {
            return false;
          }
        } else {
          return res;
        }
      },
      // 下一步
      handleNext: async () => {
        // const certFlag = certs.value.every(item => item.validateForm())
        let certFlag = await scopedMethods.checkCert(
          certs.value,
          0,
          true
        );
        const stepComplete = store.state.auth.registerInfo?.stepComplete || null
        const regType = store.state.auth.registerInfo?.regType || null
        refs.formRef.validate(async (valid) => {
          if (valid) {
            if (certFlag) {
              loadingScope.btnLoading = true
              try {
                const shareholderInfoList = []
                console.log(certs.value)
                certs.value.forEach((item, index) => {
                  console.log(item)
                  const data = {
                    backFileId: item.form.backFileId,
                    frontFileId: item.form.frontFileId,
                    idType: item.form.certType,
                    compUserId: item.form.compUserId,
                    countryCode: formReq.shareholderInfoList[index]?.countryCode
                  }
                  shareholderInfoList.push(data)
                })
                const { compId } = await getCompanyInfo()
                const { regFlag = 'add' } = formReq
                const param = { shareholderInfoList, userId: store.state.user.userId, compId }
                regFlag === 'add' ? (await addCompanyShareholderInfo(param)) : (await updateCompShareholderInfo({ updateShareholderInfoList: param.shareholderInfoList, compId }))
                localStorage.removeItem('directorInfoTemp')
                routeTo(((+stepComplete === 1 || nextOrUpdate.value === 'update') && (+regType !== 1)) ? '/auth/company/overview' : '/auth/company/businessInfo')
                loadingScope.btnLoading = false
              } catch (err) {
                loadingScope.btnLoading = false
              }
            }
          }
        })


      }
    }

    return {

      ...toRefs(refs),
      ...toRefs(loadingScope),
      ...scopedMethods,
      formReq,
      certs,
      areaCountryList,
      t,
      handleAddDirector,
      handleDelDirector,
      store
    }
  }
}

const initForm = () => {
  const store = useStore()
  const formReq = reactive({
    shareholderInfoList: [],
    compId: ''
  })

  const loadingScope = reactive({
    pageLoading: false,
    btnLoading: false
  })

  const certs = ref([])

  // 添加股东
  const handleAddDirector = () => {
    formReq.shareholderInfoList.push({
      holdInterval: false,
      sync: false,

      countryCode: "",
      certScope: {
        countryCode: '',
        certType: 'I',
        frontFileId: '',
        frontFileName: '',
        backFileId: '',
        backFileName: '',
      }
    })
  }

  // 删除股东
  const handleDelDirector = (i) => {
    if (
      (formReq.shareholderInfoList[i].userCheckStatus && !['RJ', 'ST', 'WC'].includes(formReq.shareholderInfoList[i].userCheckStatus)) ||
      formReq.shareholderInfoList[i].certScope.disabledSelect
    ) return
    formReq.shareholderInfoList.splice(i, 1)
    certs.value.splice(i, 1)
  }

  const initData = async () => {
    loadingScope.pageLoading = true
    try {
      const res = await getCompShareholderInfo()
      const directorInfoTemp = JSON.parse(localStorage.getItem('directorInfoTemp'))?.length ?
        JSON.parse(localStorage.getItem('directorInfoTemp')).map(item => ({
          sync: false,

          countryCode: item.countryCode,
          certScope: {
            holdInterval: item.holdInterval,
            certType: item.certType,
            // compUserId: item.compUserId || null,
            compUserId: null,
            frontFileId: item.frontFileId,
            frontFileName: item.frontFileName || '',
            backFileId: item.backFileId,
            backFileName: item.backFileName || '',
            disabledSelect: item.disabledSelect,

            countryCode: item.countryCode
          }
        })) : []
      if (res?.shareholderInfoList?.length) {
        formReq.shareholderInfoList = [...(directorInfoTemp), ...res.shareholderInfoList.map(item => ({
          ...item,
          countryCode: item.countryCode,
          certScope: {
            certType: item.idType,
            frontFileId: item.frontFileId,
            compUserId: item.compUserId || null,
            userCheckStatus: item.userCheckStatus,
            frontFileName: '',
            backFileId: item.backFileId,
            backFileName: '',
            holdInterval: false,

          }
        }))]
        formReq.regFlag = 'edit'
      } else {
        formReq.shareholderInfoList = directorInfoTemp.length ? directorInfoTemp : [{
          identity: '1',
          sync: false,
          countryCode: '',
          certScope: {
            holdInterval: false,
            certType: 'I',
            frontFileId: '',
            compUserId: null,
            frontFileName: '',
            backFileId: '',
            backFileName: '',
          }
        }]
        formReq.regFlag = 'add'
      }
      loadingScope.pageLoading = false
    } catch {
      loadingScope.pageLoading = false
    }
  }

  initData()

  return { formReq, loadingScope, certs, handleAddDirector, handleDelDirector }
}
</script>

<template>
  <div class="auth-container">
    <div class="tip-wrap">
      <svg-icon icon-class="叹号"
        class-name="icon" />{{ t('auth.company.shareholder.content.text_1') }}{{ t('auth.company.shareholder.content.text_2') }}{{ t('auth.company.shareholder.content.text_3') }}
    </div>
    <el-form :model="formReq" ref="formRef" :label-width="localCN ? '150px' : '230px'" label-position="left"
      v-loading="pageLoading">
      <el-row>
        <el-col :span="24">
          <div v-for="(item, index) in formReq.shareholderInfoList" :key="index">
            <p class="auth-title auth-person__subtract">
              <span>{{ t('auth.company.info.content.text_19') }}<span v-if="formReq.shareholderInfoList.length > 1">{{ index
                  + 1 }}</span></span>
              <el-button v-if="formReq.shareholderInfoList.length > 1 && !item.sync" type="danger" size="mini"
                @click="handleDelDirector(index)">{{ t('auth.company.info.content.text_18') }}</el-button>
            </p>

            <div>
              <!--证件签发地-->
              <el-form-item :prop="'shareholderInfoList.' + index + '.countryCode'"
                :rules="{ required: true, message: t('auth.company.register.error.issuingCountry'), trigger: 'change' }"
                :placeholder="t('auth.company.register.error.issuingCountry2')"
                :label="t('auth.company.register.label.issuingCountry')">
                <el-select v-model="item.countryCode" filterable>
                  <el-option v-for="country in areaCountryList" :key="country.value" :label="country.label"
                    :value="country.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <cert-type-select :ref="el => { if (el) certs[index] = el }" :scopeData="item.certScope"
               />
            </div>

            <el-form-item>
              <div class="auth-line"></div>
            </el-form-item>
          </div>

          <div class="auth-item-box" style="margin-top: 32px;">
            <div class="auth-person__add">
              <span @click="handleAddDirector">+{{ t('auth.company.shareholder.content.text_4') }}</span>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-form-item>
        <el-button class="el-button__prev" v-if="store?.state?.auth?.step != 4"
          @click="handlePrev">{{ t('auth.company.business.content.text_5') }}
        </el-button>
        <el-button class="el-button__next" type="primary" :disabled="btnLoading" v-loading="btnLoading"
          @click="handleNext">{{ t('auth.company.business.content.text_4') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>



<style lang="scss">
// @import './scss/common.scss';</style>

<style lang="scss" scoped>
// 分割线
.auth-line {
  width: 100%;
  height: 1px;
  background-color: #efefef;
}

// 新增 ex：新增董事、新增股东
.auth-person__add {
  width: 100%;
  height: 64px;
  margin-top: 22px;
  margin-bottom: 52px;
  background-color: #f9f9f9;
  border: 1px dashed #e2e2e2;
  border-radius: 4px;
  text-align: center;
  line-height: 64px;

  span {
    color: #409eff;
    cursor: pointer;
  }
}

// 删除
.auth-person__subtract {
  .el-button {
    width: 74px;
    height: 34px;
    margin-right: 130px;
    background: #ffeeee;
    border: none;
    border-radius: 3px !important;
    color: #ff4040;
    float: right;
  }
}

.auth-item-box {
  width: 920px;
  margin-left: 150px;
}

.tip-wrap {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  margin-bottom: 40px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC, serif;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  background-color: #FDF8EA;
  border-radius: 4px;
  padding: 20px 38px;
  line-height: 20px;

  &>.icon {
    width: 16px;
    height: 16px;
    margin-right: 14px;
    display: inline-block;
    transform: translateY(1px);
  }
}

:deep(.el-radio-button:first-child .el-radio-button__inner) {
  border-radius: 4px !important;
}

:deep(.el-form-item__content) {
  flex: inherit !important;
  width: auto !important;

  .el-input__inner,
  .el-textarea__inner {
    width: 360px !important;
    border-radius: 4px !important;
  }

  .el-input {
    width: auto;
  }

  .el-select {
    width: 390px !important;
    border-radius: 4px !important;
  }

  .el-input__wrapper {
    width: 100%;
  }
}
</style>
